import { siteConfig } from '@/mocks/siteConfig';
import { useEffect, useState, useRef } from 'react';

const stats = [
  { value: siteConfig.stats.totalSites, label: '收录网站', suffix: '+', icon: 'ri-global-line' },
  { value: siteConfig.stats.categories, label: '资源分类', suffix: ' 大类', icon: 'ri-folders-line' },
  { value: siteConfig.stats.dailyVisits, label: '日均访问', suffix: '+', icon: 'ri-user-smile-line' },
  { value: siteConfig.stats.updatedResources, label: '资源更新', suffix: '+', icon: 'ri-refresh-line' },
];

export default function StatsSection() {
  const [counted, setCounted] = useState(stats.map(() => 0));
  const [inView, setInView] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const countedRef = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !countedRef.current) {
          setInView(true);
          countedRef.current = true;
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!inView) return;
    const timers: ReturnType<typeof setTimeout>[] = [];
    stats.forEach((s, i) => {
      const step = Math.ceil(s.value / 60);
      const timer = setInterval(() => {
        setCounted(prev => {
          const next = [...prev];
          if (next[i] < s.value) {
            next[i] = Math.min(next[i] + step, s.value);
          }
          return next;
        });
      }, 30);
      timers.push(timer as unknown as ReturnType<typeof setTimeout>);
    });
    return () => timers.forEach(t => clearInterval(t));
  }, [inView]);

  return (
    <section ref={ref} className="w-full py-14 md:py-20 bg-accent-500">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
            磁力网站大全数据一览
          </h2>
          <p className="text-background-50/75 text-sm md:text-base">
            用数据说话，做最全面的磁力网站导航平台
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 max-w-4xl mx-auto">
          {stats.map((s, i) => (
            <div key={s.label} className="text-center">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-background-50/15 flex items-center justify-center mb-4">
                <i className={`${s.icon} text-background-50 text-2xl`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-1">
                {counted[i].toLocaleString()}{s.suffix}
              </div>
              <div className="text-sm text-background-50/70">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}